import GraphicWrapper from '../GraphicWrapper';
import styles from './Header.module.css';

interface IHeaderProps {
  title?: string;
}

const Header = ({ title = 'TOKEN TOWN' }: IHeaderProps) => {
  return (
    <div className={styles.greenBorder}>
      <GraphicWrapper
        imageDirectory="token-town"
        imageFname="cityscape-top"
        imagePosition="center center"
        imageOverlay={true}
      >
        <h1 className={`${styles.headerText} arcadeFont`}>{title}</h1>
      </GraphicWrapper>
    </div>
  );
};

export default Header;
